import { Language } from "@prisma/client";

// https://docs.aws.amazon.com/translate/latest/dg/what-is-languages.html
export const LanguageEnumToLocale: Record<
  Language,
  | "en"
  | "ar"
  | "bn"
  | "zh-TW"
  | "fa"
  | "fr"
  | "fa"
  | "ko"
  | "el"
  | "ht"
  | "he"
  | "hi"
  | "ja"
  | "ko"
  | "ml"
  | "zh-cn"
  | "pa"
  | "pt"
  | "ru-RU"
  | "es"
  | "sw"
  | "tw"
  | "ur"
  | undefined // Use this if AWS doesn't support the language
> = {
  [Language.ASL]: "en",
  [Language.ARABIC]: "ar",
  [Language.BENGALI]: "bn",
  [Language.CANTONESE]: "zh-TW",
  [Language.ENGLISH]: "en",
  [Language.FARSI]: "fa",
  [Language.FRENCH]: "fr",
  [Language.GREEK]: "el",
  [Language.HATIAN_CREOLE]: "ht",
  [Language.HEBREW]: "he",
  [Language.HINDI]: "hi",
  [Language.JAMAICAN_PATOIS]: undefined,
  [Language.JAPANESE]: "ja",
  [Language.KOREAN]: "ko",
  [Language.KRIO]: undefined,
  [Language.MALAYALAM]: "ml",
  [Language.MANDARIN]: "zh-cn",
  [Language.PORTUGUESE]: "pt",
  [Language.PUNJABI]: "pa",
  [Language.RUSSIAN]: "ru-RU",
  [Language.SPANISH]: "es",
  [Language.SWAHILI]: "sw",
  [Language.TWI]: "tw",
  [Language.URDU]: "ur",
};

/**
 * Languages with no written form, such as sign languages. A text message can't
 * be translated into one, so a family with one of these recorded reads their
 * texts in English.
 */
export const LANGUAGES_WITHOUT_WRITTEN_FORM: Language[] = [Language.ASL];
